import { STAY_TICKET_MASTER_CONFIG } from "../../../../../constants";

/**
 * guaranteedPriceの泊数合計を確定金額として提示してよいStayTicketMasterかどうかを判定する。
 */
export function canUseGuaranteedPriceAsConfirmedAmountForStayTicketMaster(
  stayTicketMasterId: string | null,
): boolean {
  if (stayTicketMasterId === null) return false;
  return STAY_TICKET_MASTER_CONFIG.some(
    (config) => config.base.stayTicketMasterId === stayTicketMasterId,
  );
}
